const prefix = {
  v1: '/api/v1',
} as const;

export const marketSegments = {
  marketName: ':marketName',
};

export const upbitPaths = {
  markets: `${prefix.v1}/market/all`,
  candles: `${prefix.v1}/candles`,
  candlesByMinute: `${prefix.v1}/candles/minutes`,
  ticker: `${prefix.v1}/ticker?markets=${marketSegments.marketName}`,
  tickerMultiple: `${prefix.v1}/ticker`,
} as const;

export const exchangePaths = {
  UPBIT: {
    markets: `${prefix.v1}/market/all`,
    ticker: `${prefix.v1}/ticker`,
    candles: `${prefix.v1}/candles/minutes`,
  },
  BITHUMB: {
    markets: `${prefix.v1}/bithumb/market/all`,
    ticker: `${prefix.v1}/bithumb/ticker`,
    candles: `${prefix.v1}/bithumb/candles/minutes`,
  },
  BINANCE: {
    markets: `${prefix.v1}/binance/market/all`,
    ticker: `${prefix.v1}/binance/ticker`,
    candles: `${prefix.v1}/binance/candles/minutes`,
  },
  // TRAD-3635 — 서버 경유(backend TRAD-3634). 🔴 candles 없음: 코인원 캔들 엔드포인트는 만들지 않는다(팀장 결정 —
  // 상세 차트는 TradingView 임베드라 candles 경로는 참조 0). 실시간은 브라우저가 WS 에 직결한다(coinoneSocket.ts).
  COINONE: {
    markets: `${prefix.v1}/coinone/market/all`,
    ticker: `${prefix.v1}/coinone/ticker`,
  },
} as const;
